import { makeAutoObservable } from "mobx"

import { PaginationListMeta } from "@framework/types/utils"
import { Entity } from "@framework/types/common"

export class PaginatedCollectionStore<Data extends Entity> {
  constructor() {
    makeAutoObservable(this)
  }

  data: Data[] = []

  error: string | null = null

  isLoading: boolean = false

  meta: PaginationListMeta = {
    total: 0,
    totalPages: 0,
    pageNum: 1,
    pageSize: 10,
  }

  reloadTrigger = 0

  setMetadata = (meta: PaginationListMeta) => {
    this.meta = meta
  }

  requestReload = () => {
    this.reloadTrigger += 1
  }
}

export default PaginatedCollectionStore
